// extracted by mini-css-extract-plugin
export default {"ag-styles":"d_g","policyPage":"d_q","introduction":"d_r","policyList":"d_s","settingsButton":"d_t"};